/**
 * PPT-section persistence. Pure localStorage; matches the irl/* store pattern.
 *
 * Today's only job: remember analyst contact info (partner + 2 MDs) so the
 * Findings form auto-fills next time. Stored once globally — same humans
 * across deals.
 */

const CONTACTS_KEY = "__pptFindingsContacts";

export type SavedContacts = {
  /** Map of input key (e.g. "contact_1_name") → value. */
  values: Record<string, string>;
};

export function getSavedContacts(): SavedContacts {
  try {
    const raw = localStorage.getItem(CONTACTS_KEY);
    return raw ? (JSON.parse(raw) as SavedContacts) : { values: {} };
  } catch {
    return { values: {} };
  }
}

export function saveContacts(values: Record<string, string>): void {
  try {
    // Only persist keys that look like contact_<N>_<field>.
    const filtered: Record<string, string> = {};
    for (const [k, v] of Object.entries(values)) {
      if (/^contact_\d+_/.test(k) && v.trim()) filtered[k] = v;
    }
    localStorage.setItem(CONTACTS_KEY, JSON.stringify({ values: filtered }));
  } catch {
    // ignore quota errors
  }
}
